<template>
    <v-dialog v-model="Vmodel" @click:outside="close">
        <v-card color="blue-grey lighten-5">
            <v-container>
                <v-row justify="center" align="start">
                    <v-col cols="12" lg="4" order="2" order-lg="1">
                        <SystemDataCard :utcInfos="utcInfos" class="mb-4" />
                        <BatteryCard :utcInfos="utcInfos" class="mb-4" />
                        <FileCard
                            ref="inputFile"
                            :utcInfos="utcInfos"
                            @update:file="$emit('update:file', $event)"
                        />
                    </v-col>
                    <v-col cols="12" lg="8" order="1" order-lg="2" >
                        <EnvironmentalMetricsCard :utcInfos="utcInfos" class="mb-4" />
                        <ControlsCard
                            :utcInfos="utcInfos"
                            @validate="emitValidate"
                        />
                    </v-col>    
                </v-row> 
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import SystemDataCard from './UTCDialog/SystemDataCard.vue';
import BatteryCard from './UTCDialog/BatteryCard.vue';
import FileCard from './UTCDialog/FileCard.vue';
import EnvironmentalMetricsCard from './UTCDialog/EnvironmentalMetricsCard.vue';
import ControlsCard from './UTCDialog/ControlsCard.vue';
export default {
    name: "UTCDialog",
    components: {
        SystemDataCard,
        BatteryCard,
        FileCard,
        EnvironmentalMetricsCard,
        ControlsCard,
    },
    props: {
        Vmodel: Boolean,
        utcInfos: Object,
    },
    methods: {
        close() {
            this.$refs.inputFile.removeFile();
            this.$emit('close');
        },
        emitValidate(e){
            this.$emit('validate', e);
        },        
    }
}
</script>
<style scoped>
  ::v-deep .v-dialog {
    max-height: 100% !important;
  }
</style>